import type { ExportStatus } from '@/lib/api/reports-client.js';
import { cn } from '@/lib/utils.js';

interface StatusBadgeProps {
  status: ExportStatus;
  label: string;
}

const STATUS_STYLES: Record<ExportStatus, string> = {
  queued:
    'bg-[var(--color-qup-text-muted-dark)]/15 text-[var(--color-qup-text-muted-dark)] border-[var(--color-qup-text-muted-dark)]/30',
  running: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  completed:
    'bg-[var(--color-qup-success)]/15 text-[var(--color-qup-success)] border-[var(--color-qup-success)]/30',
  failed:
    'bg-[var(--color-qup-error)]/15 text-[var(--color-qup-error)] border-[var(--color-qup-error)]/30',
  cancelled: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30',
};

export function StatusBadge({ status, label }: StatusBadgeProps) {
  return (
    // N-2: <output> is the semantic HTML element for a live-region status result.
    // aria-live="polite" is implicit on <output>; SR announces changes when idle.
    <output
      data-testid="status-badge"
      data-status={status}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium',
        STATUS_STYLES[status],
      )}
    >
      {status === 'running' && (
        <span
          aria-hidden="true"
          className="inline-block h-2 w-2 animate-spin rounded-full border border-current border-t-transparent"
        />
      )}
      {label}
    </output>
  );
}
